import React, { useState } from 'react'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'
import { severity } from 'core/utils'
import { strCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import { deleteWind2errors, getWind2errors, updateWind2errors } from 'api/pgads'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import { Label } from 'core/screen-util'
import { Button, Input, Select } from 'antd'

const title = 'Wind Error Codes Managament'

const Wind2Errors = _ => {
  const [insertEvent, setInsertEvent] = useState(false)
  const InsertComp = ({ insertData = {}, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '200px 200px 100px 200px auto auto auto',
          gap: 10,
        }}
      >
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Error Code :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        {/* <Label>Error Code :</Label> */}
        <Input
          value={insertData.errorcode}
          data-cy="errorcode"
          onChange={e =>
            setInsertData({
              ...insertData,
              errorcode: e.target.value,
            })
          }
        />
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Severity :
          </Label>
        </div>
        {/* <Label>Severity :</Label> */}
        <Select
          value={severity[insertData.severity]}
          data-cy="severity"
          style={{ width: '100px' }}
          onChange={value => setInsertData({ ...insertData, severity: value })}
        >
          {Object.keys(severity).map(m => (
            <Select.Option key={m} data-cy="severity">
              {severity[m]}
            </Select.Option>
          ))}
        </Select>
        <div style={{ gridColumnEnd: 'span 3' }} />

        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Error Description :
          </Label>
        </div>

        {/* <Label>Error Description :</Label> */}
        <Input
          style={{ gridColumnEnd: 'span 3' }}
          value={insertData.error}
          data-cy="errordescription"
          onChange={e =>
            setInsertData({
              ...insertData,
              error: e.target.value,
            })
          }
        />

        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>
        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    )
  }

  return (
    <CommonScreen
      title={title}
      header={Wind2ErrorHeaders}
      saveTask={updateWind2errors}
      retrieveTask={getWind2errors}
      deleteTask={deleteWind2errors}
      autoRetrieve
      // widthOffset={50}
      insertComp={insertEvent && InsertComp}
      insertCompHeight={150}
      onInsertEvent={b => setInsertEvent(b)}
      autoFixColByKey={false}
      headerRowHeight={30}
      totalWidth={150 + 650 + 400 + 150}
      sortOptions={Wind2ErrorHeaders}
      defaultInsertData={{ severity: 0 }}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(Wind2Errors)

const Wind2ErrorHeaders = [
  strCol({
    ident: 'errorcode',
    display: 'Error Code',
    isKey: true,
    width: 150,
    // ellipsis: true,
    // alignment: 'left',
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'severity',
    display: 'Severity',
    isKey: false,
    sortOrder: 'asc',
    width: 150,
    ...toSelectionColProps(severity),
    isRequired: true,
  }),
  strCol({
    ident: 'error',
    display: ' Description',
    isFiltered: true,
    width: 700,
    ellipsis: true,
    alignment: 'left',
  }),
  modifierCol,
  modifiedDateCol,
]
